import { ReferentielModel } from './referentiel.model';
import { DiscProgramModel } from './disc-program.model';
import { DiscDetailModel } from './product-disc-detail.model';

export class DiscModel {
  public id: number = null;
  public refEan: string = null;
  public label: string = null;
  public support: ReferentielModel = new ReferentielModel();
  public pressingFormat: ReferentielModel = new ReferentielModel();
  public discDetail: DiscDetailModel = new DiscDetailModel();
  public programs: DiscProgramModel[] = [];
  public formattedEan: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
